import { FileUploadTypeEnum } from '../../generated/api';
import { createContext, useContext } from 'react';

interface VideoPlayerSyncState {
    isPlayingGlobal: boolean;
    setIsPlayingGlobal: (playing: boolean) => void;
    maxDurationGlobal: number;
    setMaxDurationGlobal: (duration: number, videoType: FileUploadTypeEnum) => void;
    maxDurationVideoType: FileUploadTypeEnum;
    seekTimeGlobal: number;
    setSeekTimeGlobal: (time: number) => void;
    isMobileView: boolean;
    setIsMobileView: (isMobileView: boolean) => void;
    videosStarted: boolean;
    setVideosStarted: (started: boolean) => void;
    videosWatched: boolean;
    setVideosWatched: (watched: boolean) => void;
    videosEnded: { videoType: FileUploadTypeEnum; ended: boolean }[];
    setVideoEnded: (videoType: FileUploadTypeEnum, ended: boolean) => void;
    allVideosEnded: () => boolean;
    startPlayFromBeginning: boolean;
    setStartPlayFromBeginning: (startPlayFromBeginning: boolean) => void;
}

const VideoPlayerSyncContext = createContext<VideoPlayerSyncState | null>(null);

const useVideoPlayerSync = () => {
    const context = useContext(VideoPlayerSyncContext);
    if (!context) {
        throw new Error('useVideoPlayerSync must be used within a VideoPlayerSyncProvider');
    }
    return context;
};

export { VideoPlayerSyncContext, useVideoPlayerSync };
